<div class="ability-cards-dialog">
  <div class="menu">
    @if (levelToPick) {
    <p class="title" [ghs-label]="'character.abilities.pickCard'" [ghs-label-args]="[levelToPick]"></p>
    }
    @if (character.progress.deck.length && deck) {
    <a ghs-pointer-input (singleClick)="undoLastCard()" (doubleClick)="resetDeck()"
      [ghs-label]="'character.abilities.undoLastPick'"
      [ghs-label-args]="[levelToPick ? levelToPick-1 : character.level]"
      [ghs-tooltip]="'character.abilities.undoLastPick.hint'"></a>
    }
    @if (!levelToPick) {
    <div class="levels">
      @for (l of additionalLevels; track l) {
      <a class="level" ghs-pointer-input (singleClick)="setLevel(l)" (doubleClick)="setLevel(l,true)"
        [ngClass]="{'active' : level == l, 'exclusive': exclusiveLevel == l}" [ghs-label]="l"></a>
      }
      @if (additionalLevels.length) {
      <span class="separator">|</span>
      }
      @for (l of [] | ghsRange:(deck ? maxLevel : 9); track l) {
      <a class="level" ghs-pointer-input (singleClick)="setLevel(l+1)" (doubleClick)="setLevel(l+1,true)"
        [ngClass]="{'active' : level == l+1, 'exclusive': exclusiveLevel == l+1}">{{l+1}}</a>
      }
    </div>
    }
    @if (!levelToPick) {
    <select [(ngModel)]="sort" (change)="update()">
      @for (value of sorts; track value) {
      <option [value]="value" [ghs-label]="'character.abilities.sort.' + value">
      </option>
      }
    </select>
    }
    <a [ghs-label]="deck ? 'character.abilities.show' : 'character.abilities.showDeck'" (click)="togglePick()"></a>

    @if (!levelToPick) {
    <img class="enhancement" src="./assets/images/character/enhancements.svg" ghs-pointer-input
      (singleClick)="toggleEnhanced()" (doubleClick)="openEnhancementDialog()" [ngClass]="{'active' : enhanced}">
    }
    @if (character.progress.deck.length > character.level -1) {
    <p class="warning" [ghs-label]="'character.abilities.deckWarning'"></p>
    }
    @if (maxLevel > character.level) {
    <p class="warning" [ghs-label]="'character.abilities.levelWarning'">
    </p>
    }
  </div>
  <div class="scroll-container">
    <div class="abilities">
      @if (!exclusiveLevel && !levelToPick && !enhanced) {
      <div class="container">
        <ghs-ability [character]="character"></ghs-ability>
      </div>
      }
      @for (ability of visibleAbilities | trackUUID; track ability._trackUUID;) {
      <div class="container ability"
        [ngClass]="{'pick': levelToPick, 'in-deck': ability.level == 1 || ability.level == 'X' || character.progress.deck.indexOf(abilities.indexOf(ability)) != -1,'always': ability.level == 1 || ability.level == 'X',  'disabled': character.progress.deck.indexOf(abilities.indexOf(ability)) == -1 && (levelToPick < +ability.level || cardsToPick < 1)}">
        <ghs-ability [ability]="ability" [character]="character" [flipped]="true" ghs-pointer-input
          (singleClick)="clickAbility(ability)" (doubleClick)="openDialog(ability)"></ghs-ability>
        @if (!deck) {
        <img class="deck" src="./assets/images/character/deck.svg" ghs-pointer-input
          (doubleClick)="toggleDeck(ability,true)"
          [ghs-tooltip]="character.progress.deck.indexOf(abilities.indexOf(ability)) != -1 ? 'character.abilities.removeFromDeck' : 'character.abilities.forceDeck'">
        }
      </div>
      }
    </div>
    @if (smallAbilities.length) {
    <p class="title" [ghs-label]="'character.abilities.currentDeck'"></p>
    }
    @if (smallAbilities.length) {
    <div class="abilities">
      @for (ability of smallAbilities | trackUUID; track ability._trackUUID) {
      <div class="container small ability" (click)="openDialog(ability)">
        <ghs-ability [ability]=" ability" [character]="character" [flipped]="true"></ghs-ability>
      </div>
      }
    </div>
    }
  </div>
</div>